// src/native/auth/nativeAuthError.js
//
// WS-2 AUTH-NATIVE. One place that turns any failure into a real Error object
// carrying a translation key.
//
// Callers on the existing web path read `error.message` and render a generic
// t('login.failed'), so the shape stays compatible with what AuthContext
// already returns. `i18nKey` is additive: a native UI layer can show a specific
// message, and nothing that exists today has to know the field is there.

/**
 * @param {string} message developer facing, ends up in logs and PostHog
 * @param {string} i18nKey key in src/native/_i18n/WS-2.strings.json
 * @param {unknown} [cause] the original thrown value, if any
 * @returns {Error}
 */
export function nativeAuthError(message, i18nKey, cause) {
  const err = cause instanceof Error ? cause : new Error(message);
  if (!(cause instanceof Error)) err.message = message;
  err.i18nKey = i18nKey;
  err.nativeAuth = true;
  if (cause !== undefined && !(cause instanceof Error)) err.cause = cause;
  return err;
}
